import React from "react";

const GcAvatar = ({
	className = ""
}: {
	className?: string;
}) => (
	<div className={`avatar gotcourts ${className}`}></div>
);

export default GcAvatar;
